import { Pipe, SecurityContext, VERSION, NgModule } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Nl2BrPipe = /** @class */ (function () {
    function Nl2BrPipe(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @param {?=} sanitizeBeforehand
     * @return {?}
     */
    Nl2BrPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} sanitizeBeforehand
     * @return {?}
     */
    function (value, sanitizeBeforehand) {
        if (typeof value !== 'string') {
            return value;
        }
        /** @type {?} */
        var result;
        /** @type {?} */
        var textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
        if (!VERSION || VERSION.major === '2') {
            result = this.sanitizer.bypassSecurityTrustHtml(textParsed);
        }
        else if (sanitizeBeforehand) {
            result = this.sanitizer.sanitize(SecurityContext.HTML, textParsed);
        }
        else {
            result = textParsed;
        }
        return result;
    };
    Nl2BrPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'nl2br'
                },] }
    ];
    /** @nocollapse */
    Nl2BrPipe.ctorParameters = function () { return [
        { type: DomSanitizer }
    ]; };
    return Nl2BrPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var Nl2BrPipeModule = /** @class */ (function () {
    function Nl2BrPipeModule() {
    }
    Nl2BrPipeModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [Nl2BrPipe],
                    imports: [],
                    exports: [Nl2BrPipe]
                },] }
    ];
    return Nl2BrPipeModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Nl2BrPipeModule, Nl2BrPipe };

//# sourceMappingURL=nl2br-pipe.js.map